import { render } from "./CaptureTwitter.vue?vue&type=template&id=0dc3d212&ts=true&lang=html"
import script from "./CaptureTwitter.vue?vue&type=script&lang=ts"
export * from "./CaptureTwitter.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__